import {DateTime, IANAZone} from "luxon";
import dateTimeMedium from "../filters/dateTimeMedium";

export class Timezone {

    id: string;
    locale: string;

    constructor(identifier: string, locale = 'en') {
        this.id = identifier
        this.locale = locale
    }

    get shortName(): string {
        const zone = new IANAZone(this.id);

        try {
            return zone.offsetName(new Date().getTime(), {
                format: 'short',
                locale: this.locale
            })
        } catch {
            return zone.name;
        }
    }

    getLocalTime(locale: string = 'en'): string {
        return dateTimeMedium(DateTime.local({zone: this.id}).toString(), locale, this.id);
    }
}
